module.exports = __webpack_public_path__ + "staticcomp/img/content_3.dab3494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/8/content_3.jpg
// module id = pJwn
// module chunks = 39